import { css } from 'lit';
import componentStyles from '../styles/component.styles';
import formStyles from '../styles/forms.styles';
export default css `
  ${componentStyles}
  ${formStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    display: block;
    line-height: 1;
  }

  .checkbox {
    display: inline-flex;
    cursor: pointer;
    position: relative;
    margin-bottom: var(--p-input-margin-bottom);
  }

  .checkbox-text {
    padding-left: 8px;
    padding-top: 2px;
  }

  :host([label-hidden]) {
    line-height: 1;
  }

  .label-hidden .checkbox-text {
    padding: 0;
  }

  .checkbox:hover .checkbox-input {
    border-color: var(--p-input-border-color-hover);
  }

  .checkbox-input {
    min-width: 20px;
    height: 20px;
    width: 20px;
    margin: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    border: 1px solid var(--p-input-border-color);
    border-radius: 4px;
    outline: none;
    transition:
      background 0.2s ease,
      border 0.2s ease,
      outline 0s;
    background-color: var(--p-input-bg);
    cursor: pointer;
  }

  .checkbox-input:checked {
    border-color: transparent !important;
    background-color: var(--p-brand);
  }

  .checkbox-input:focus-visible {
    border-color: var(--p-input-border-color-focus);
    outline: 2px solid var(--p-input-border-color-focus);
  }

  .checkbox-wrap {
    position: relative;
    height: 20px;
  }

  .checkbox-svg {
    position: absolute;
    left: 0;
    top: 0;
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    visibility: hidden;
    transform: scale(0.2);
    transition: all 0.2s ease;
    pointer-events: none;
  }

  .checkbox-svg svg {
    display: block;
    fill: var(--p-brand-contrast);
  }

  .checkbox-input:checked + .checkbox-svg {
    opacity: 1;
    visibility: visible;
    transform: scale(1);
    transition-delay: 0.1s;
  }

  /**
--------------------------------------------------
* Error
--------------------------------------------------
*/
  .has-error .checkbox-input {
    border-color: var(--p-error);
  }

  slot::slotted(a) {
    color: inherit;
  }

  /**
--------------------------------------------------
* Toggle
--------------------------------------------------
*/
  .toggle-slot {
    display: none;
    padding: 15px;
    background-color: var(--p-bg-light);
    border: 1px solid var(--p-border);
    border-radius: 5px;
    margin-bottom: 10px;
  }
`;
